/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PhoneNumberInput } from './PhoneNumberInput';
import {
    PhoneNumberInputFromJSON,
    PhoneNumberInputFromJSONTyped,
    PhoneNumberInputToJSON,
    PhoneNumberInputToJSONTyped,
} from './PhoneNumberInput';

/**
 * SSO user pre-creation request
 * @export
 * @interface CreateSsoUserRequest
 */
export interface CreateSsoUserRequest {
    /**
     * User email address (must match SSO identity)
     * @type {string}
     * @memberof CreateSsoUserRequest
     */
    email: string;
    /**
     * User first name
     * @type {string}
     * @memberof CreateSsoUserRequest
     */
    firstName?: string;
    /**
     * User last name
     * @type {string}
     * @memberof CreateSsoUserRequest
     */
    lastName?: string;
    /**
     * Preferred username/display name for the user (optional, defaults to email if not provided)
     * @type {string}
     * @memberof CreateSsoUserRequest
     */
    preferredUsername?: string;
    /**
     * SSO identity provider (must match the provider used for SSO authentication)
     * @type {string}
     * @memberof CreateSsoUserRequest
     */
    identityProvider: CreateSsoUserRequestIdentityProviderEnum;
    /**
     * Phone numbers for the user (optional, supports multiple phone numbers)
     * @type {Array<PhoneNumberInput>}
     * @memberof CreateSsoUserRequest
     */
    phoneNumbers?: Array<PhoneNumberInput>;
    /**
     * Extended metadata/attributes for the user (optional, JSON object for custom fields)
     * @type {{ [key: string]: any; }}
     * @memberof CreateSsoUserRequest
     */
    metadata?: { [key: string]: any; };
    /**
     * Tenant ID where user will be created
     * @type {string}
     * @memberof CreateSsoUserRequest
     */
    tenantId: string;
    /**
     * Role ID to assign to user (direct role assignment)
     * @type {string}
     * @memberof CreateSsoUserRequest
     */
    roleId?: string;
    /**
     * Role name to assign to user (alternative to roleId)
     * @type {string}
     * @memberof CreateSsoUserRequest
     */
    roleName?: string;
    /**
     * Group ID to add user to (group-based role assignment)
     * @type {string}
     * @memberof CreateSsoUserRequest
     */
    groupId?: string;
    /**
     * Group name to add user to (alternative to groupId)
     * @type {string}
     * @memberof CreateSsoUserRequest
     */
    groupName?: string;
    /**
     * Preferred timezone for the user (overrides tenant default)
     * @type {string}
     * @memberof CreateSsoUserRequest
     */
    preferredTimezone?: string;
}


/**
 * @export
 */
export const CreateSsoUserRequestIdentityProviderEnum = {
    AzureAd: 'AZURE_AD',
    Okta: 'OKTA',
    Google: 'GOOGLE',
    Custom: 'CUSTOM'
} as const;
export type CreateSsoUserRequestIdentityProviderEnum = typeof CreateSsoUserRequestIdentityProviderEnum[keyof typeof CreateSsoUserRequestIdentityProviderEnum];


/**
 * Check if a given object implements the CreateSsoUserRequest interface.
 */
export function instanceOfCreateSsoUserRequest(value: object): value is CreateSsoUserRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('identityProvider' in value) || value['identityProvider'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    return true;
}

export function CreateSsoUserRequestFromJSON(json: any): CreateSsoUserRequest {
    return CreateSsoUserRequestFromJSONTyped(json, false);
}

export function CreateSsoUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSsoUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'preferredUsername': json['preferredUsername'] == null ? undefined : json['preferredUsername'],
        'identityProvider': json['identityProvider'],
        'phoneNumbers': json['phoneNumbers'] == null ? undefined : ((json['phoneNumbers'] as Array<any>).map(PhoneNumberInputFromJSON)),
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'tenantId': json['tenantId'],
        'roleId': json['roleId'] == null ? undefined : json['roleId'],
        'roleName': json['roleName'] == null ? undefined : json['roleName'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'preferredTimezone': json['preferredTimezone'] == null ? undefined : json['preferredTimezone'],
    };
}

export function CreateSsoUserRequestToJSON(json: any): CreateSsoUserRequest {
    return CreateSsoUserRequestToJSONTyped(json, false);
}

export function CreateSsoUserRequestToJSONTyped(value?: CreateSsoUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'preferredUsername': value['preferredUsername'],
        'identityProvider': value['identityProvider'],
        'phoneNumbers': value['phoneNumbers'] == null ? undefined : ((value['phoneNumbers'] as Array<any>).map(PhoneNumberInputToJSON)),
        'metadata': value['metadata'],
        'tenantId': value['tenantId'],
        'roleId': value['roleId'],
        'roleName': value['roleName'],
        'groupId': value['groupId'],
        'groupName': value['groupName'],
        'preferredTimezone': value['preferredTimezone'],
    };
}

